import { render, staticRenderFns } from "./addMedicalCase.vue?vue&type=template&id=de61b356&scoped=true&"
import script from "./addMedicalCase.vue?vue&type=script&lang=js&"
export * from "./addMedicalCase.vue?vue&type=script&lang=js&"
import style0 from "./addMedicalCase.vue?vue&type=style&index=0&id=de61b356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de61b356",
  null
  
)

export default component.exports